import {request} from './request'

// 实时---------------------------------------------------------------------
export function CreditPorjectRealtimeTrend() {
    return request({
        url: '/hp/realtime/trend/',
        params: {}
    });
}

export function CreditPorjectRealtimeArea() {
    return request({
        url: '/hp/realtime/area/',
        params: {}
    });
}
export function CreditPorjectRealtimeType() {
    return request({
        url: '/hp/realtime/type/',
        params: {}
    });
}

export function CreditPorjectRealtimeData(eia_type, page, page_size=20) {
    return request({
        url: '/hp/realtime/datas/',
        params: {
            eia_type,
            page,
            page_size,

        }
    });
}


// 数据查询 -------------------------------------------------------------
export function CreditPorjectDataSearch(province, city, main_type_name, type_name, eia_type, min_date, max_date, page_size, page, search) {
    return request({
        url: '/hp/credit-projects/',
        params: {
            min_date,
            max_date,
            type_name,
            main_type_name,
            city,
            province,
            eia_type,
            page_size,
            page,
            search,
        }
    });
}

export function CompileUnitDataSearch(province, city, page_size, page, search) {
    return request({
        url: '/hp/compile-units/',
        params: {
            city,
            province,
            page_size,
            page,
            search,
        }
    });
}

export function CompileHostDataSearch(compile_unit__province, compile_unit__city, page_size, page, search) {
    return request({
        url: '/hp/compile-hosts/',
        params: {
            compile_unit__province,
            compile_unit__city,
            page_size,
            page,
            search,
        }
    });
}


export function getAreaData(area = '全国', recently = '全部时间', project_type = '全部行业') {
    return request({
        url: '/hp/project-analysis/area/',
        params: {
            area,
            recently,
            project_type
        }
    });
}


export function getIndustryData(area = '全国', recently = '全部时间', project_type = '全部行业') {
    return request({
        url: '/hp/project-analysis/type/',
        params: {
            area,
            recently,
            project_type
        }
    });
}

export function getTimeData(area = '全国', recently = '全部时间', project_type = '全部行业') {
    return request({
        url: '/hp/project-analysis/time/',
        params: {
            area,
            recently,
            project_type
        }
    });
}

export function getProvinces(province__city = '全国') {
    return request({
        url: '/hp/citys/',
        params: {
            province__city,
        }
    });
}


export function HighYieldHostDataSearch(area, cityvalue, recently, page_size, page, search) {
    return request({
        url: '/hp/public-supervision/high-yield-host/',
        params: {
            area,
            cityvalue,
            recently,
            page_size,
            page,
            search,
        }
    });
}

export function IsProvinceProjectDataSearch(area, cityvalue, recently, page_size, page, search) {
    return request({
        url: '/hp/public-supervision/provincial-project/',
        params: {
            area,
            cityvalue,
            recently,
            page_size,
            page,
            search,
        }
    });
}

export function DiscreditPersonDataSearch(discreditable_type, min_date, max_date, page_size, page, search) {
    return request({
        url: '/hp/discredit-persons/',
        params: {
            discreditable_type,
            min_date,
            max_date,
            page_size,
            page,
            search,
        }
    });
}